/**
 * @generated SignedSource<<466e387e2d7f19ddccc75fc67620b3f9>>
 * @relayHash 7957163491f238365d93b879b1aff514
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44250e02f9fe76688123a843576b6ec3fda477f73dee2a8ce061ede10d51d60b

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterHomePageLayout",
        "kind": "LinkedField",
        "name": "homePageLayout",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLayoutAdf",
          "kind": "LinkedField",
          "name": "layoutAdf",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdfContentConnection",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "content"
                }]
              }]
            }]
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "44250e02f9fe76688123a843576b6ec3fda477f73dee2a8ce061ede10d51d60b",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "8173462403df3b7e32282c5a49757d5b";
export default node;